<template>
  <section class="app-container">
    <van-dropdown-menu>
      <van-dropdown-item v-model="params.pickerTime" @change="handleTimeChange" :options="params.pickerTimeOptions" />
    </van-dropdown-menu>
    <component :is="currentList" :orders="orders"></component>
  </section>
</template>
<script>
import { Dialog, DropdownMenu, DropdownItem } from 'vant'
import Available from './components/Available'
import Unavailable from './components/Unavailable'
import { deepClone, parseTime } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'Invoice-Temporary',
  computed: {
    ...mapGetters(['wx_userInfo', 'wx_token', 'token'])
  },
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Dialog.Component.name]: Dialog.Component,
    Available,
    Unavailable
  },
  data () {
    return {
      currentList: 'Unavailable',
      orders: [],
      params: {
        pickerTime: 1,
        parkId: 0,
        outTradeNo: null,
        pickerTimeOptions: [
          { text: '今天', value: 1 },
          { text: '最近一周', value: 7 },
          { text: '最近一个月', value: 30 },
          { text: '最近三个月', value: 90 }
        ],
        startDate: [
          parseTime(new Date(new Date().toLocaleDateString())),
          parseTime(
            new Date(
              new Date(new Date().toLocaleDateString()).getTime() +
              24 * 60 * 60 * 1000
            )
          )
        ],
      },
    }
  },
  mounted () {
    this.componentsValve()
  },
  methods: {
    // 时间选项改变
    handleTimeChange (val) {
      this.params.startDate[1] = parseTime(new Date(new Date(new Date().toLocaleDateString()).getTime() + val * 24 * 60 * 60 * 1000))
      this.componentsValve()
    },
    // 查询数据
    componentsValve () {
      let _this = this
      let data = []
      let getInfo_Loading = _this.$toast.loading('加载中...')
      setTimeout(() => {
        getInfo_Loading.clear()
        for (let i = 0; i < 10; i++) {
          let item = {
            orderNum: i * 10000,
            parkName: '众彩物流地下停车场',
            plateNmuber: '苏A5B618',
            date: parseTime(new Date(new Date().toLocaleDateString())),
            paidMoney: i,
            nsrsbh: i + 1
          }
          if (typeof item.paidMoney === 'number') {
            item.priceArr = item.paidMoney.toFixed(2).split('.')
          }
          data.push(item)
        }
        if (Object.keys(data).length > 0) {
          _this.orders = deepClone(data)
          _this.currentList = 'Available'
        } else {
          _this.currentList = 'Unavailable'
        }
      }, 1000)
    },
    onClickRight () {
      Dialog.alert({
        title: '开票说明',
        message: '仅支持最近3个月内的缴费记录开票'
      })
    }
  }
}
</script>